"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "url(#messengerGradient) #000000",
    d: "M3.751 11.751c0-4.6 3.603-8.003 8.25-8.003s8.25 3.403 8.25 8.003-3.603 8.003-8.25 8.003a9 9 0 0 1-2.386-.316.66.66 0 0 0-.445.036l.004-.002-1.644.722a.66.66 0 0 1-.929-.583v-.001l-.048-1.471a.66.66 0 0 0-.22-.467l-.001-.001a7.82 7.82 0 0 1-2.586-5.815l.001-.11v.006zm5.72-1.505-2.42 3.85c-.241.365.22.784.564.516l2.606-1.974a.484.484 0 0 1 .598 0l1.925 1.444a1.24 1.24 0 0 0 1.788-.33l2.42-3.85c.241-.365-.22-.777-.564-.516l-2.606 1.974a.475.475 0 0 1-.592 0l-1.925-1.444a1.237 1.237 0 0 0-1.792.325z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("radialGradient", {
        id: "messengerGradient",
        cx: "19.247%",
        cy: "99.465%",
        r: "108.96%",
        fx: "19.247%",
        fy: "99.465%",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0%",
          stopColor: "#09F"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "60.975%",
          stopColor: "#A033FF"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "93.482%",
          stopColor: "#FF5280"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "100%",
          stopColor: "#FF7061"
        })]
      })
    })
  })]
}), 'Messenger');
//# sourceMappingURL=index.js.map